import { onLCP } from 'web-vitals/attribution';
import type { LCPMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';
import { toLcpReport } from './mappers';

const onLargestContentfulPaint = (report: (m: MetricReport) => void): void => {
  onLCP((metric: LCPMetricWithAttribution) => {
    report(toLcpReport(metric));
  });
};

export default onLargestContentfulPaint;
